export const 
    SET_XL_COMPLAINT_PARAMS = 'SET_XL_COMPLAINT_PARAMS';


// WEBPACK FOOTER //
// ./src/types/CreateXLComplaint.js